export default __webpack_public_path__ + "static/media/person-chairman1.c4cc32b5.png";